import React, {useEffect, useState} from 'react';

export default function Results({dataFolder, chains, pdb, pn, mol1, mol2}) {

    const [combinations, setCombinations] = useState([]);

    useEffect(() => {
        const combinations = chains.ranges_set_1.flatMap((item1) => {

            return chains.ranges_set_2.map(item2 => {
                const urlDataFolder = btoa(dataFolder);
                const pdbFile = btoa(pdb.trim());
                const chain1 = btoa(item1.chain);
                const chain2 = btoa(item2.chain);
                const pnenc = btoa(pn);
                const mol1enc = btoa(mol1);
                const mol2enc = btoa(mol2);
                const url = `/BioTools/cocomaps2/mols?f=${urlDataFolder}&p=${pdbFile}&c1=${chain1}&c2=${chain2}&pn=${pnenc}&mol1=${mol1enc}&mol2=${mol2enc}`

                return {chain1: item1.chain, chain2: item2.chain, url: url};
            });
        });

        const unique_combinations = combinations.filter(combination => combination.chain1 !== combination.chain2).reduce((acc, comb) => {
            if (!acc.find(valid_comb => valid_comb.chain1 === comb.chain2 && valid_comb.chain2 === comb.chain1)) {
                acc.push(comb);
            }
            return acc;
        }, []);

        setCombinations(unique_combinations);
    }, [dataFolder, chains, pdb, pn, mol1, mol2])

    return (
        <div style={{padding: '30px'}}>
            <h1>Explore results:</h1>
            <p>Access to the results will be available for three months from the date of job submission.</p>
            <ul>
                {combinations.map((item, index) => (
                    <li key={index}>
                        <a href={item.url} target="_blank" rel="noopener noreferrer" style={{fontSize: '16px'}}>{item.name}
                            {item.chain1} vs {item.chain2}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    )
}